import { z } from 'zod';
import { sizeSchema, coordinateSchema } from '../../Shared.js';

const legacyCanvasDrawingSchema = z.object({
  id: z.string(),
  position: coordinateSchema,
  size: sizeSchema,
  points: z.array(coordinateSchema),
  style: z.object({
    lineWidth: z.number(),
    color: z.string()
  })
});

export { legacyCanvasDrawingSchema };
//# sourceMappingURL=LegacyCanvasDrawing.js.map
